import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Toggler from '@fiverr/ui_toggle';
import classNames from 'classnames';
import CommentPanelButton from '../CommentPanelButton';
import CommentsPanel from '../CommentsPanel';
import * as SettingsSelectors from '../../selectors/settings';
import * as Selectors from '../../selectors';
import withErrorReport from '../../hocs/withErrorReport';

import './style.scss';

export function CollaborationSidebar({
    isCollaborationEnabled,
    shouldDisplayOpen,
    onOpen,
    onClose
}) {
    if (!isCollaborationEnabled) {
        return null;
    }

    const defaultOpen = shouldDisplayOpen && isCollaborationEnabled;

    return (
        <Toggler defaultOpen={defaultOpen}
            bindBodyClickListener={false}
            togglerDidOpen={onOpen}
            togglerDidClose={onClose}>
            {({
                isOpen,
                toggle,
                preventCloseAction
            }) => (
                <div className={classNames('collaboration-content-wrapper', { 'shown': isOpen })} ref={preventCloseAction}>
                    <CommentPanelButton key={1} onClick={toggle} isOpen={isOpen}/>
                    <CommentsPanel key={2} isOpen={isOpen}/>
                </div>
            )}
        </Toggler>
    );
}

CollaborationSidebar.propTypes = {
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isCollaborationEnabled: PropTypes.bool,
    shouldDisplayOpen: PropTypes.bool
};

CollaborationSidebar.defaultProps = {
    onOpen: () => null,
    onClose: () => null,
    isCollaborationEnabled: false,
    defaultTogglerOpen: false
};

const mapStateToProps = (state) => ({
    isCollaborationEnabled: SettingsSelectors.isCollaborationAsked(state) && Selectors.isCollaborationDataReady(state)
});

export default compose(
    withErrorReport('CollaborationSidebar'),
    connect(mapStateToProps)
)(CollaborationSidebar);
